import miniCardMorePng from "src/assets/images/mini_card/more.png";
import { MiniCardProps } from "../types";

const MiniCardMoreDefaultProps: Partial<MiniCardProps> = {
	title: "more",
	content: {
		variant: "Image",
		alt: "More",
		src: miniCardMorePng,
	},
	testID: "MiniCardMore",
};
export default MiniCardMoreDefaultProps;
